import React, { Component } from 'react';
// import Center from 'react-center';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  NavLink,
  Alert,
  Button,
  Navbar,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem } from 'reactstrap';
import {
  SPI_MONITOR_REDUCERNAME,
  spiMonitorReducer,
  dismissErrorAction
} from './SpiMonitorReducer';
import PropTypes from 'prop-types';

class Menu extends Component {
  constructor (props) {
    super(props);
    this.state = {
    };
  }

  render () {
    const { dispatch, spiMonitor } = this.props;

    return (
      <div className='navbar-wrapper'>
        <Navbar light expand='md' className='navbar-static-top navbar'>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className='container-fluid'>
              <NavItem navbar>
                <NavLink active>Neerslagindex (SPI)</NavLink>
              </NavItem>
              <NavItem navbar>
                <NavLink href='https://www.knmi.nl/kennis-en-datacentrum/achtergrond/achtergrondinformatie-neerslagindex-spi'>Uitleg</NavLink>
              </NavItem>
              <NavItem navbar className='ml-auto'>
                <NavLink href='https://www.knmi.nl/kennis-en-datacentrum/uitleg/early-warning-centre'>Early Warning Centre</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
        {/* {spiMonitor.errors && spiMonitor.errors.length > 0 && (
          <Row>
            <Col>
              <Alert color='danger'>
                <Row>
                  <Col xs='11'>Something is wrong &#9785;</Col>
                  <Col xs='1' style={{ float: 'right' }}>
                    <Button
                      onClick={() => {
                        dispatch(dismissErrorAction());
                      }}
                    >
                      X
                    </Button>
                  </Col>
                </Row>
                {spiMonitor.errors.map((element, key) => {
                  return (
                    <Row key={key}>
                      <Col xs='1'>{key + 1}):</Col>
                      <Col xs='11'>
                        <div className={'errorMessageBody'}>
                          <div className={'errorMessageTitle'}>
                            {element.message}
                          </div>
                          <div className={'errorMessageMessage'}>
                            {element.error.message}:
                          </div>
                          <div className={'errorMessageDetails'}>
                            {JSON.stringify(element.error)}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </Alert>
            </Col>
          </Row>
        )} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    spiMonitor: state[SPI_MONITOR_REDUCERNAME]
      ? state[SPI_MONITOR_REDUCERNAME]
      : spiMonitorReducer()
  };
};

Menu.propTypes = {
  dispatch: PropTypes.func,
  spiMonitor: PropTypes.object
};

export default connect(mapStateToProps)(Menu);
